import { takeLatest } from 'redux-saga/effects';
import { mainMenuDetailsActions } from './mainMenuSlice';
import callFetchMainMenuDetailsSaga from './sagas/callFetchMainMenuDetailsSaga';

export default function* mainMenuDetailsSaga() {
  yield takeLatest(mainMenuDetailsActions.fetchMainMenuDetails, callFetchMainMenuDetailsSaga);
}
